<template>
  <div>
    <p v-dompurify-html="message" class="auth-box__message" />

    <ElButton
      type="primary"
      class="auth-box__submit"
      native-type="submit"
      size="large"
      :loading="isSubmitting"
      @click.native="registerAgent"
    >
      {{ $t('REGISTER_AGENT') }}
    </ElButton>
  </div>
</template>

<script>
import { Agents } from '@/api/api';

export default {
  name: 'RegisterAgentWithoutPassword',
  props: {
    publisherEmail: {
      type: String,
      default: '',
    },
    agentEmail: {
      type: String,
      default: '',
    },
    token: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isSubmitting: false,
    };
  },
  computed: {
    message() {
      if (!this.agentEmail || !this.publisherEmail) return '';
      return this.$t('REGISTER_AGENT.HAS_PASSWORD', {
        user_email: this.agentEmail,
        publisher_email: this.publisherEmail,
      });
    },
  },
  methods: {
    registerAgent() {
      this.isSubmitting = true;
      return Agents.registerAgent(
        {},
        {
          token: this.token,
        },
      )
        .then(({ body: { message, token } }) => {
          if (message) {
            this.$message.success(message);
          }
          this.$emit('success', token);
        })
        .catch(({ body: { message } }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
